<template>
    <div class="form-container">
        <form @submit.prevent>
            <input v-model="email" type="email" id="email" placeholder="Email adress">

            <input v-model="firstName" type="text" id="firstName" placeholder="First Name">

            <input v-model="lastName" type="text" id="lastName" placeholder="Last Name">

            <input v-model="password" type="password" id="password" placeholder="Password">

            <input type="password" id="passwordConfirm" placeholder="Confirm Password">

            <div v-if="badCredentialsMessage" class="invalidCredentials">
                Invalid credentials
            </div>
            <button :class="{loading}" @click="registerUser">Subscribe</button>

            <div class="actions">
                <router-link :to="{name: 'login'}">Already registred?</router-link>
            </div>
        </form>
    </div>

</template>

<script>
    export default {
        name: "Subscribe"
    }
</script>

<style scoped lang="scss">
    form{
        width: 500px;
        margin: 100px auto auto;
        border: 2px solid var(--main-green);
        border-radius: 2px;
        padding: 40px 20px 20px;
        color: white;

        label{
            display: block;
            width: 60%;
            margin: auto;
            text-align: left;
        }

        input[type="text"], input[type="email"], input[type="password"]{
            font-size: 14px;
            display: block;
            width: 60%;
            height: 30px;
            margin: auto auto 15px;
            border: 1px solid;
            border-radius: 2px;
            padding: 3px;
        }

        button{
            font-size: 15px;
            font-weight: 700;
            display: block;
            width: 60%;
            margin: auto;
            border: 0;
            border-radius: 3px;
            padding: 5px;
            color: white;
            background-color: black;
            cursor: pointer;
        }

        .actions{
            font-size: 14px;
            margin-top: 20px;

            a{
                display: block;
                color: black;
            }
        }
    }
</style>
